import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://api.lbw.plus/api/',
  headers: {
    Authorization: 'Bearer tokenapi',
  },
});

export const authAPI = {
  create(email, password, referral) {
    let bodyFormData = new FormData();
    bodyFormData.append('email', email);
    bodyFormData.append('password', password);
    bodyFormData.append('referrer_code', referral);

    return instance
      .post(`user/create`, bodyFormData)
      .then((response) => response.data);
  },

  login(email, password) {
    let bodyFormData = new FormData();
    bodyFormData.append('email', email);
    bodyFormData.append('password', password);

    return instance
      .post(`user/login`, bodyFormData)
      .then((response) => response.data);
  },

  logout(userId) {
    return instance
      .post(`user/logout/${userId}`)
      .then((response) => response.data);
  },
};

export const userAPI = {
  getUser(userID, userToken) {
    return instance
      .get(`user/get/${userID}`, {
        params: {
          user_token: userToken,
        },
      })
      .then((response) => response.data);
  },

  getUserStatistics(userID, userToken) {
    return instance
      .get(`user/get/statistics/${userID}`, {
        params: {
          token: userToken,
        },
      })
      .then((response) => response.data);
  },

  setUserBitcoinAddress(userID, userToken, bitcoinAddress) {
    let bodyFormData = new FormData();
    bodyFormData.append('bitcoin_address', bitcoinAddress);
    bodyFormData.append('id', userID);
    bodyFormData.append('user_token', userToken);

    return instance
      .post(`user/set/${userID}`, bodyFormData)
      .then((response) => response.data);
  },
  confirmCode(userID, userToken, code) {
    let bodyFormData = new FormData();
    bodyFormData.append('code', code);
    bodyFormData.append('user_token', userToken);
    bodyFormData.append('id', userID);
    return instance
      .post(`user/confirm_code/${userID}`, bodyFormData)
      .then((response) => response.data);
  },
};

export const appAPI = {
  async getLastVersion() {
    try {
      const response = await instance.get('/updates');
      return response.data;
    } catch (error) {
      console.log('Error refreshing version:', error);
    }
  },
};
